module.exports = __webpack_public_path__ + "img/p3.b308fb6f.jpg";